/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
export var ColumnMovingMode = /*@__PURE__*/ (function (ColumnMovingMode) {
    ColumnMovingMode[ColumnMovingMode["Deferred"] = 0] = "Deferred";
    ColumnMovingMode[ColumnMovingMode["None"] = 1] = "None";
    return ColumnMovingMode;
})({});
/**
 * @hidden
 */
export var ColumnMovingMode_$type = /*@__PURE__*/ markEnum('ColumnMovingMode', 'Deferred,0|None,1');
//# sourceMappingURL=ColumnMovingMode.js.map
